import { API_URLS } from 'config/constants';
import httpServices from './http.service';

export const createProduct = (data: Product.Item) => (
  httpServices.post(API_URLS.PRODUCT.CREATE, data)
);

export const getProduct = (id: string) => (
  httpServices.get(API_URLS.PRODUCT.GET.replace('[id]', id))
);

export const editProduct = ({ id, product }: { id: string, product: Product.Item }) => (
  httpServices.patch(API_URLS.PRODUCT.EDIT.replace('[id]', id), product)
);
export const getProducts = (params?: {
  skip: number; limit: number; name?: string; priceOrder?: 'asc' | 'desc'; forFeed?: boolean; inStock?: boolean;
}) => (
  httpServices.get(API_URLS.PRODUCT.ALL, { params })
);

export const changeProductForFeed = ({ id, forFeed }: { id: string; forFeed: boolean }) => (
  httpServices.patch(API_URLS.PRODUCT.CHANGE_FOR_FEED.replace('[id]', id), { forFeed })
);

export const addReview = ({ link, review }: { link: string; review: { name: string; stars: number; description: string } }) => (
  httpServices.post(API_URLS.PRODUCT.ADD_REVIEW.replace('[link]', link), review)
);

export const generatePromForProduct = ({ id }: { id: string }) => (
  httpServices.post(API_URLS.PRODUCT.GENERATE_PROM.replace('[id]', id))
);

export type PromGenerateAllStatus = {
  running: boolean;
  total: number;
  processed: number;
  failed: number;
  startedAt: string | null;
  finishedAt: string | null;
};

export const getPromGenerateAllStatus = () => (
  httpServices.get<PromGenerateAllStatus>(API_URLS.PRODUCT.GENERATE_PROM_ALL_STATUS)
);

export const generatePromForAll = (body?: { keywordsOnly?: boolean; onlyMissing?: boolean }) => (
  httpServices.post<{ started: boolean; total?: number; status?: PromGenerateAllStatus }>(
    API_URLS.PRODUCT.GENERATE_PROM_ALL,
    body,
  )
);
